import React, { Component } from 'react'
import { siteContent } from '@services/api'
import { Icon } from 'antd'
import DeleteTable from '../DeleteTable'

export default class extends Component {
    constructor(props) {
        super(props)

        this.state = {
            compName: props.compName,
            newContent: [{ key: '', value: '' }],
            compArr: []
        }
    }
    componentDidMount() {
        let { compName, arr } = this.props
        compName.length && this.setState({ compArr: arr.filter(comp => comp.component == compName) })
    }
    render() {
        const { compName, newContent, compArr } = this.state
        let { updateSiteContent, arr, id } = this.props
        let marginRight = { marginRight: 7 }
        return (
            <>
                {this.props.compName.length ? (
                    <DeleteTable arr={compArr} updateSiteContent={updateSiteContent} />
                ) : (
                    <>
                        <h6 style={{ color: 'red' }}> לא לשכוח להוסיף _</h6>
                        <input
                            defaultValue={compName}
                            onChange={e => this.setState({ compName: e.target.value })}
                            placeholder="שם הקומפננטה"
                        />
                    </>
                )}
                {newContent.map((slot, idx) => (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flex: 1,
                            alignItems: 'center'
                        }}
                        key={idx}
                    >
                        <h6>מפתח:</h6>
                        <input
                            style={marginRight}
                            value={slot.key}
                            onChange={e =>
                                this.setState({
                                    newContent: newContent.map((item, i) =>
                                        i === idx ? { ...item, key: e.target.value } : item
                                    )
                                })
                            }
                        />
                        <h6>תוכן:</h6>
                        <input
                            style={marginRight}
                            value={slot.value}
                            onChange={e =>
                                this.setState({
                                    newContent: newContent.map((item, i) =>
                                        i === idx ? { ...item, value: e.target.value } : item
                                    )
                                })
                            }
                        />
                        <Icon
                            style={marginRight}
                            type="delete"
                            onClick={() => this.setState({ newContent: newContent.filter((_, i) => i !== idx) })}
                        />
                    </div>
                ))}
                <Icon
                    type="plus"
                    onClick={() => this.setState({ newContent: [...newContent, { key: '', value: '' }] })}
                />
                <Icon
                    style={marginRight}
                    type="check"
                    onClick={async () => {
                        let validator =
                            (!!newContent.filter(pair => !pair.value.length || !pair.key.length).length &&
                                'אין לשמור שדות ריקים') ||
                            (!this.props.compName.length &&
                                arr.filter(slot => slot.component == compName).length &&
                                'קיימת קומפוננטה עם השם הזה') ||
                            (this.props.compName.length &&
                                newContent.some(item =>
                                    arr
                                        .filter(slot => slot.component == compName)
                                        .map(slot => slot.key.key)
                                        .includes(item.key)
                                ) &&
                                'קיים מפתח כזה בקומפוננטה') ||
                            false
                        if (validator) alert(validator)
                        else {
                            if (!newContent.some(item => arr.map(arrIt => arrIt.key.value).includes(item.value))) {
                                let keys = {}
                                newContent.map(pair => (keys[pair.key] = pair.value))
                                await siteContent.addComp({ component: compName, keys, id })
                                updateSiteContent()
                            } else {
                                let newValues = newContent.map(it => it.value)
                                let arrValues = arr.filter(item => newValues.indexOf(item.key.value) + 1)
                                alert(
                                    `קיים מפתח עם התוכן הזה ב${arrValues
                                        .map(item => `${item.component}.${item.key.key}`)
                                        .join(', ')}`
                                )
                            }
                        }
                    }}
                />
            </>
        )
    }
}
